<template>
  <div class="cashManagement">
    <div class="topLayout">
      <div class="container_">
        <div>可提现余额</div>
        <div>￥{{pageData.balanceDetails}}</div>
        <div>
          注：此账户用于文章购买产生的相关收益。支付宝将收取每笔0.6%的交易手续费，由龙源传媒集团完成代缴。
          支付宝支付的结算周期为T+3, 提现申请后,
          3个工作日后款项会自动转至您的支付宝钱包
        </div>
      </div>
      <div class="button_" @click="toView()">提现</div>
    </div>

    <div class="bottomLayout">
      <div class="theHeader">
        <div class="inputWap">
          <!-- <div class="settingStyle">
            <el-select
              v-model="pageData.orderOptions.value"
              clearable
              placeholder="当月订单"
            >
              <el-option
                v-for="item in pageData.orderOptions.list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div> -->
          <div class="settingStyle">
            <el-select
              v-model="pageData.stateOptions.value"
              clearable
              placeholder="全部状态"
            >
              <el-option
                v-for="item in pageData.stateOptions.list"
                :key="item.type"
                :label="item.name"
                :value="item.type"
              />
            </el-select>
          </div>
          <div class="buttonStyle" @click="articleGetUserArticle()">搜索</div>
        </div>
      </div>

      <div class="tableWtyle">
        <el-table
          :data="pageData.tableData"
          height="500"
          style="width: 100%"
          :header-cell-style="{
            background: '#F5F7FA',
            color: '#303133',
            fontWeight: '800',
          }"
        >
          <el-table-column label="">
            <template #default="scope">
              <div>
                {{
                  (totalnum.page - 1) * totalnum.pageSize + (scope.$index + 1)
                }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="提现时间">
            <template #default="scope">
              <div>
                {{ scope.row.withdrawalTime || "-" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="到账账户">
            <template #default="scope">
              <div>
                {{ scope.row.cashAccount || "-" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="账户类型">
            <template #default="scope">
              <div>
                {{
                  scope.row.type == 1
                    ? "支付宝"
                    : scope.row.type == 2
                    ? "微信"
                    : scope.row.type == 3
                    ? "银行卡"
                    : "-"
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="金额">
            <template #default="scope">
              <div>
                {{ scope.row.withdrawalAmount || "-" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="到账时间">
            <template #default="scope">
              <div>
                {{ scope.row.arriveTime || "-" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template #default="scope">
              <div>
                {{
                  scope.row.status == 1
                    ? "待审核"
                    : scope.row.status == 2
                    ? "待打款"
                    : scope.row.status == 3
                    ? "提现成功"
                    : scope.row.status == 4
                    ? "提现失败"
                    : "-"
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="申请人">
            <template #default="scope">
              <div>
                {{ scope.row.realName || "-" }}
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" width="200">
            <template #default="scope">
              <el-button type="text" @click="toView(scope.row)">详情</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <pagingComponent
        @handleCurrentChangeSub="noChangePagination"
        :currentPage="totalnum.page"
        :rows="totalnum.pageSize"
        :total="totalnum.total"
      />
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { withdrawalAmount , withdrawalSelectWithdrawalList } from "../../api/interfaceList";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import { reactive, computed , onMounted } from "vue";
import pagingComponent from "@/components/pagingComponent/index";
export default {
  name: "cashManagement",
  setup() {
    const router = useRouter();
    let pageData = reactive({
      balanceDetails:'',
      tableData: [],
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      orderOptions: {
        value: "",
        list: [],
      },
      stateOptions: {
        value: null,
        list: [
          {
            name: "全部",
            type: null,
          },
          {
            name: "待审核",
            type: 1,
          },
          {
            name: "待打款",
            type: 2,
          },
          {
            name: "提现成功",
            type: 3,
          },
          {
            name: "提现失败",
            type: 4,
          },
        ],
      },
      orderDetailsShow: false,
      orderDetails: "",
    });
    let totalnum = computed(() => {
      return pageData.page;
    });
    function noChangePagination(res) {
      pageData.tableData = [];
      pageData.page.page = res;
      articleGetUserArticle();
    }
    function toView() {
      router.push("withdrawalSetting");
    }

    withdrawalAmount({
      usercode: JSON.parse(Cookies.get("userInformation")).userCode,
    }).then((res) => {
      if (res.code == 1) {
        pageData.balanceDetails = res.data
      } else {
        ElMessage({
          message: res.message,
        });
      }
    })
    function articleGetUserArticle() {
      withdrawalSelectWithdrawalList({
        userCode: JSON.parse(Cookies.get("userInformation")).userCode,
        status: pageData.stateOptions.value,
        page: pageData.page.page,
        pageSize: pageData.page.pageSize,
      }).then((res) => {
        if (res.code == 1) {
          pageData.tableData = res.data.records;
          pageData.page.total = res.data.pages;
        } else {
          ElMessage({
            message: res.message,
          });
        }
      });
    }
    onMounted(()=>{
      articleGetUserArticle()
    })
    return {
      pageData,
      totalnum,
      noChangePagination,
      toView,
      articleGetUserArticle,
    };
  },
  components: {
    pagingComponent,
  },
};
</script>
<style lang="scss" scope>
.cashManagement {
  width: 1050px;
  .topLayout {
    width: 100%;
    background: rgba(5, 213, 97, 0.15);
    border-radius: 6px;
    padding: 10px 30px;
    box-sizing: border-box;
    margin-bottom: 13px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .container_ {
      width: 486px;
      div {
        font-weight: 700;
        font-family: AlibabaPuHuiTiB;
        color: #2f744f;
        line-height: 32px;
      }
      div:nth-of-type(1) {
        font-size: 12px;
      }
      div:nth-of-type(2) {
        font-size: 24px;
      }
      div:nth-of-type(3) {
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #4a9c5e;
        line-height: 16px;
      }
    }
    .button_ {
      width: 160px;
      height: 40px;
      font-size: 13px;
      font-family: AlibabaPuHuiTiM;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      background: #4a9c5e;
      border-radius: 6px;
      cursor: pointer;
    }
  }
  .bottomLayout {
    width: 100%;
    padding: 4px 30px 10px 30px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 8px;
    .tableWtyle {
      width: 100%;
      margin-top: 16px;
      div {
        width: 100%;
        text-align: center;
      }
    }
    .theHeader {
      width: 100%;
      padding-bottom: 12px;
      border-bottom: 1px solid #f7f7f7;
      padding: 12px 0;
      box-sizing: border-box;
      .inputWap {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .settingStyle {
          width: 136px;
          margin-right: 10px;
        }
        .buttonStyle {
          width: 72px;
          height: 40px;
          font-size: 13px;
          font-family: AlibabaPuHuiTiM;
          color: #ffffff;
          line-height: 40px;
          text-align: center;
          background: #008aea;
          border-radius: 6px;
          text-align: center;
          cursor: pointer;
          transition: 0.3s all;
          margin-left: 10px;
        }
        .buttonStyle:hover {
          background: #55b2fb;
        }
      }
    }
  }
}
</style>
